import PopConfirmRed from '@/pages/ApplyBasic/component/PopConfirmRed'

const components = [
  PopConfirmRed
]

const install = function (Vue) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

export default install



// WEBPACK FOOTER //
// ./src/pages/ApplyBasic/component/index.js